import Client from '../layouts/client';
import LayoutFilerLandmark from '../../models/layout-filters/landmark';
import LayoutPosition from '../../models/layout_position';
import { asyncPaginatedFetch } from '../../utilities/http-utilities';

export default class LayoutFilterClient extends Client {
  constructor(layoutId, destinationId, token, date) {
    super(layoutId, destinationId, token)
    this.date = date
  }

  async fetchLandmarks() {
    const landmarks = await asyncPaginatedFetch(`${this.API_BASE_URL}/landmarks?layout_id=${this.layoutId}`);
    return landmarks.map(landmark => LayoutFilerLandmark.fromAttributes(landmark));
  }

  async fetchPositions() {
    const positions = await asyncPaginatedFetch(`${this.API_BASE_URL}/filtered_layout_positions?layout_id=${this.layoutId}&start_date=${this.date}`);
    return positions.map(position => LayoutPosition.fromAttributes(position));
  }

  async saveLayout(positions, startDate, endDate) {
    const data = {
      layout_filter_positions_attributes: positions.map(position => position.serialize()),
      layout_id: this.layoutId,
      destination_id: this.destinationId,
      starts_at: startDate,
      ends_at: endDate
    }

    const { response, error } = await this.postData(`${this.API_BASE_URL}/layout_filters`, data);
    return { response, error };
  }
}
